import * as styles from "./SelectValue.css";

import { clsx } from "clsx";

import { Select as BaseSelect } from "@base-ui/react/select";

import type { SelectValueProps } from "./Select.types";

export function SelectValue({ className, ...props }: SelectValueProps) {
  return (
    <BaseSelect.Value className={clsx(styles.value, className)} {...props} />
  );
}
